import { create } from 'zustand';
import clone from 'lodash/clone';
import AuthorizationFormState from 'src/shared-components/AuthorizationModal/types';
import { GTAGPrefix } from './useGTAG';

interface ModalState {
  modalsConfig: { [key: string]: boolean };
  listOfNotificationModals: {
    id: string;
    translitName: string;
    name: string;
    gtagPrefix: GTAGPrefix;
  }[];
  updateModalsConfig: (key: string, visible: boolean) => void;
  isModalVisible: (key: string) => boolean;
  clearModalsConfigWithException: (exceptionKey?: string) => void;
  authFormState: AuthorizationFormState;
  setAuthFormState: (authformState: AuthorizationFormState) => void;
  addNotificationModal: (newModal: {
    id: string;
    translitName: string;
    name: string;
    gtagPrefix: GTAGPrefix;
  }) => void;
}

const useModalStore = create<ModalState>()((set, get) => ({
  modalsConfig: {},
  listOfNotificationModals: [],
  addNotificationModal: (newModal: {
    id: string;
    translitName: string;
    name: string;
    gtagPrefix: GTAGPrefix;
  }) =>
    set((state) => {
      if (
        !state.listOfNotificationModals?.find(
          (modal) => modal.translitName === newModal.translitName
        )
      ) {
        return {
          listOfNotificationModals: [
            ...state.listOfNotificationModals,
            newModal
          ]
        };
      }
      return { listOfNotificationModals: state.listOfNotificationModals };
    }),
  authFormState: AuthorizationFormState.LOGIN,
  updateModalsConfig: (key: string, visible: boolean) =>
    set((state) => {
      const newConfig = clone(state.modalsConfig);
      newConfig[key] = visible;
      return { modalsConfig: newConfig };
    }),
  setAuthFormState: (authState: AuthorizationFormState) =>
    set({ authFormState: authState }),
  isModalVisible: (key: string) => get().modalsConfig[key],
  clearModalsConfigWithException: (exceptionKey?: string) =>
    set(() => {
      const newConfig = {};
      if (exceptionKey) {
        newConfig[exceptionKey] = true;
      }
      return { modalsConfig: newConfig };
    })
}));

export default useModalStore;
